import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for L413 (ISO正式發行文件查詢)
// ============================================================

export interface ISODocumentItem {
  fl030_01: string; // ISO文件編號
  fl030_11: string; // 文件名稱
  fl030_12: string; // 條文類別
  fl030_13: string; // 版本
  fl030_14: number; // 頁次
  fl030_15: string; // 階層
  fl030_16: string; // 修改日期 (YYYY-MM-DD)
}

export interface QueryResponse {
  items: ISODocumentItem[];
  total: number;
}

export interface SectionItem {
  fl130_01: string; // ISO文件編號 FK
  fl130_02: number; // 章節序號
  fl130_11: string; // 章節名稱
  fl130_12: string; // 章節內容
}

export interface SectionsResponse {
  items: SectionItem[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const l413Api = {
  /** Query ISO document records with optional keyword filter */
  async queryDocuments(params: {
    keyword?: string;
  }): Promise<QueryResponse> {
    const p: Record<string, string> = {};
    if (params.keyword?.trim()) p['keyword'] = params.keyword.trim();
    const res = await apiClient.get('/api/l413/documents', { params: p });
    return res.data;
  },

  /** Get sections for a specific ISO document */
  async querySections(docId: string): Promise<SectionsResponse> {
    const res = await apiClient.get(`/api/l413/documents/${encodeURIComponent(docId)}/sections`);
    return res.data;
  },
};
